import {
  element,
  IDirective,
  IDocumentService,
  IFormController,
  INgModelController,
  IScope,
  ITimeoutService
} from 'angular';
import { GmcRecaptchaService } from './gmc-recaptcha.service';

export interface IGmcRecaptchaDirectiveScope extends IScope {
  widgetId: number;
  response: string;
  required: boolean;
  theme: 'light' | 'dark';
  onCreate: ( data ) => void;
  onSuccess: ( data ) => void;
  onExpire: ( data ) => void;
}

export interface IGmcRecaptchaDirectiveCtrls {
  formCtrl: IFormController;
  modelCtrl: INgModelController;
}

export function gmcRecaptchaDirective( gmcRecaptchaService: GmcRecaptchaService,
                                       $document: IDocumentService,
                                       $timeout: ITimeoutService ): IDirective {
  return {
    restrict: 'A',
    require: {
      modelCtrl: 'ngModel'
    },
    scope: {
      theme: '@',
      widgetId: '=?',
      response: '=ngModel',
      required: '<?',
      onCreate: '&',
      onSuccess: '&',
      onExpire: '&'
    },
    link: function postLink( scope: IGmcRecaptchaDirectiveScope,
                             $element,
                             attr,
                             ctrl: IGmcRecaptchaDirectiveCtrls ) {
      scope.widgetId = null;
      const modelCtrl = ctrl.modelCtrl;

      if ( attr.required ) {
        scope.$watch('required', validate);
      }

      gmcRecaptchaService.create($element, {
        sitekey: null,
        theme: scope.theme,
        callback: recaptchaCallback,
        'expired-callback': expired
      })
        .then(( widgetId ) => {
          scope.widgetId = widgetId;
          scope.onCreate({ $event: { widgetId } });
          scope.$on('$destroy', onDestroy);
          scope.$on('reCaptchaReset', ( event, resetWidgetId ) => {
            if ( resetWidgetId && resetWidgetId === widgetId ) {
              scope.response = '';
              validate();
            }
          });
        });

      function expired() {
        $timeout(() => {
          scope.response = '';
          validate();
          scope.onExpire({ $event: { widgetId: scope.widgetId } });
        });
      }

      function recaptchaCallback( recaptchaResponse: string ) {
        $timeout(() => {
          scope.response = recaptchaResponse;
          validate();
          scope.onSuccess({ $event: { response: recaptchaResponse, widgetId: scope.widgetId } });
        });
      }

      function onDestroy() {
        resetValidation();
        gmcRecaptchaService.deleteWidget(scope.widgetId);
        gmcRecaptchaService.reload(scope.widgetId);
        element($document[ 0 ].querySelectorAll('.pls-container')).parent().remove();
      }

      function resetValidation() {
        modelCtrl.$setValidity('recaptcha', null);
      }

      function validate() {
        modelCtrl.$setValidity('recaptcha', scope.required ? !!scope.response : null);
      }
    }
  };
}

gmcRecaptchaDirective.$inject = [
  'GmcRecaptchaService',
  '$document',
  '$timeout'
];



// WEBPACK FOOTER //
// ./app/shared/directives/gmc-recaptcha/gmc-recaptcha.directive.ts